import { ReactNode } from 'react'
import clsx from 'clsx'

import { Drawer, makeStyles } from '@material-ui/core'

import { useMenuStatus } from 'UI/Components'
import { useAuth } from 'hooks'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
    drawerPaper: {
        backgroundColor: '#f5f5f5',
        border: 'none'
    },
    drawerOpen: {
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
        height: '100vh',
        width: drawerWidth
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: '70px',
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) - 2
        }
    },
    drawerHovered: {
        width: drawerWidth,
        boxShadow: '4px 0px 15px rgba(0, 0, 0, 0.25)',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    }
}))

type Props = {
    children: ReactNode
}

export const DrawerBody = ({ children }: Props) => {
    const classes = useStyles()
    const { isNotLogged } = useAuth()

    const { isMenuClosed, setIsMenuClosed, initiallyClosed } = useMenuStatus()

    if (isNotLogged) return null

    return (
        <Drawer
            variant="permanent"
            anchor="left"
            style={{ position: 'relative' }}
            className={clsx({
                [classes.drawerOpen]: !initiallyClosed,
                [classes.drawerClose]: initiallyClosed
            })}
            classes={{
                paper: clsx(classes.drawerPaper, {
                    [classes.drawerOpen]: !isMenuClosed && !initiallyClosed,
                    [classes.drawerHovered]: !isMenuClosed && initiallyClosed,
                    [classes.drawerClose]: isMenuClosed
                })
            }}
            onMouseOver={() => {
                if (isMenuClosed) {
                    setIsMenuClosed(false)
                }
            }}
            onMouseLeave={() => {
                if (initiallyClosed) {
                    setIsMenuClosed(true)
                }
            }}
        >
            {children}
        </Drawer>
    )
}
